/* ════ UNDO (planner moves / resizes) ══════════════════════ */
// Each entry: { id, before: { start, end, half, resource } }.
const stack = [];
export function pushUndo(entry) { stack.push(entry); if (stack.length > 50) stack.shift(); }
export function popUndo() { return stack.pop(); }
export function canUndo() { return stack.length > 0; }
